import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '../../../screen-video-container/user';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { ScreenDetailsModel } from '../screen-details-model';
import { FavoriteButtonService } from './favorite-button.service';

@Component({
    selector: 'gtw-favorite-button',
    templateUrl: './favorite-button.component.html',
    styleUrls: ['./favorite-button.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FavoriteButtonComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Output()
  screenChange = new EventEmitter<ScreenDetailsModel>();
      
  @Input()
  screen: ScreenDetailsModel = {};

  @Input('base-url')
  baseUrl = '/gtw';

  @Input('client-key')
  clientKey: number = 0;

  @Input()
  user:User= {sso:'000000000', role:'none',system_access_level:'0'};

  sso_id?: string;

  constructor(private favoriteSrvice : FavoriteButtonService,
              private _gtwSnackbarService:GtwSnackbarService) {}

  ngOnInit(): void {
  }

  public favBtnCheck (): void {
    let temp  = 'N';
    if(this.screen.IS_FAV === 'Y') {
      temp = 'N';
    } else {
      temp = 'Y';
    }
    
    this.favoriteSrvice.updateFavorite(this.baseUrl,this.clientKey,this.screen.SCREEN_KEY!,temp).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data:any) => {
        if(data && data.callSuccess==1){
          this.screen.IS_FAV = temp;
          this.screenChange.emit(this.screen);
        }else{
          this._gtwSnackbarService.openSnackBar('Sorry!! Something went wrong. Please try again later.', "gtw-snackbar--red");
        }
      },(error)=>{
        this._gtwSnackbarService.openSnackBar('Sorry!! Something went wrong. Please try again later.', "gtw-snackbar--red");
      });
  }

}
